import { Box } from '@mantine/core';
import { getHIColourByStatus } from '../lib/status-color';

export const StatusDot = ({
  severity,
  dimmed,
}: {
  severity: number | null;
  dimmed?: boolean;
}) => (
  <Box
    w={8}
    h={8}
    style={{
      borderRadius: '50%',
      flexShrink: 0,
      backgroundColor:
        dimmed || severity == null
          ? 'var(--mantine-color-dimmed)'
          : getHIColourByStatus(severity),
    }}
  />
);